
import { KTIcon, toAbsoluteUrl } from "../../../_metronic/helpers"
import { StepperComponent } from "../../../_metronic/assets/ts/components";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import fetchAPI from "../../../common/fetchAPI";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Select, { StylesConfig } from 'react-select';
import { getAllDataInSingleRequestAsync } from "./CustomReportDesignSlice";
import { accountReportInitialsForAdd, accountReportInitialsForUpdate } from "../interfaces/ReportClasses";
import {
  GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportIdAsync,
  addAccountReportAsync, addReportOrdersAsync
} from './CustomReportDesignSlice';
import ListBoxWidget from "./ListBoxWidget";
// import DraggableList from "../../../common/DraggableList";
import DraggableList from "../../../common/DraggableList";
import { useFileUpload } from './FileUploadContext';
import { ShowSwal } from "../../../common/SweetAlert";
import React from "react";
import { ShowToast } from '../../../common/Toastr';
import { isGuid, dropDownSelectionStyles, getValueFromResource } from "../../../common/timeLiveFunction";
import { useTranslation } from "react-i18next";
import { getParentChildPagePermissionsAsync } from '../../../common/GlobalSlice';
import Loader from "../../../common/Loader";
import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";
import { useRuntimeConfig } from "../../../hooks/useRuntimeConfig";

const itemClass = 'ms-1 ms-lg-3';
const userAvatarClass = 'symbol-35px symbol-md-35px';
const btnClass = 'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px';
const btnIconClass = 'fs-1 text-gray-600';
const initialValuesForPermissions = {
  IsReportDesignWizard: false
}

export const CustomReportDesign = () => {

  const emptyGuid = '00000000-0000-0000-0000-000000000000';
  // const { state } = useLocation();
  // const { accountReportId } = state;
  // const AccountReportId = accountReportId || '00000000-0000-0000-0000-000000000000';

  const location = useLocation();
  const tabStepper = location.state?.tabStepper ?? 1;
  // const AccountReportId = (location.state?.accountReportId && location.state?.accountReportId !== '')
  //   ? location.state.accountReportId
  //   : emptyGuid;
   const { AccountReportId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { selectedRecord, isLoading, accountReportColumnList } = useAppSelector((state) => state.customReportDesign);
  const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, maxMenuHeight, sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);
  const { t } = useTranslation();

  const textBoxRefs = useRef<(HTMLInputElement | null)[]>([]);
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)

  const [isSubmitButton, setSubmitButton] = useState(false)
  const [currentStepperIndex, setCurrentStepperIndex] = useState(1)

  const [currentFieldsData, setCurrentFieldsData] = useState<any>(accountReportInitialsForAdd)

  const [reportCategoryArray, SetReportCategoryArray] = useState<any | ''>([]);
  const [systemReportDataSourceArray, setSystemReportDataSourceArray] = useState<any | ''>([]);
  const [systemReportSummaryArray, setSystemReportSummaryArray] = useState<any | ''>([]);
  const [reportColumnsForColumnOrderArray, setReportColumnsForColumnOrderArray] = useState<any | ''>([]);
  const [reportGroupForGroupOrderArray, setReportGroupForGroupOrderArray] = useState<any | ''>([]);
  const [arrayOfArrays, setArrayOfArrays] = useState<any[]>([]);
  
  const [selectedSystemReportDataSourceOption, setSelectedSystemReportDataSourceOption] = useState(null);
  const [systemReportDataSourceIdForReportCustomaize, setSystemReportDataSourceIdForReportCustomaize] = useState('');

  const [selectedOptionRadio, setSelectedOptionRadio] = useState(false);
  const { selectedFile, setFile } = useFileUpload();
  const [childs, setChilds] = useState(initialValuesForPermissions);
  const Parent_SystemSecurityCategoryPageId: string = "124";
  const [isLoadingLocal, setIsLoadingLocal] = useState(false);
  const [accountReportIdLast, setAccountReportIdLast] = useState(emptyGuid);
  const [isDataReady, setIsDataReady] = useState(false);
  const config = useRuntimeConfig();

  useLayoutEffect(() => {
    const fetchPagePermissions = async () => {
      if (Parent_SystemSecurityCategoryPageId && Parent_SystemSecurityCategoryPageId !== '') {
        getPermissions(Parent_SystemSecurityCategoryPageId, "127")
      }
    }
    fetchPagePermissions();
  }, [dispatch]);

  const getPermissions = (SystemSecurityCategoryPageId: string, ChildSystemSecurityCategoryPageIds: string) => {
    dispatch(getParentChildPagePermissionsAsync({ SystemSecurityCategoryPageId: SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds: ChildSystemSecurityCategoryPageIds }))
      .unwrap()
      .then((originalPromiseResult) => {
        if (originalPromiseResult.ParentPermission) {
          if (originalPromiseResult.ParentPermission.IsList && originalPromiseResult.ChildPermission) {
            const childPermission: any = originalPromiseResult.ChildPermission;
            const isReportDesignWizard = childPermission.filter((x: any) => x.Id === 127)[0].IsList;
            setChilds({
              ...childs,
              IsReportDesignWizard: isReportDesignWizard
            });
            if (!isReportDesignWizard) {
              navigate('../error/403');
            }
          }
          else {
            navigate('../error/403');
          }
        }
        else {
          navigate('../error/403');
        }
      })
      .catch((rejectedValueOrSerializedError) => {
      })
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFile(file);
      setCurrentFieldsData({ ...currentFieldsData, 'ReportIconPath': file?.name })
    }
  };

  const handleMoveUpColumns = (newColumns: any) => {
    setReportColumnsForColumnOrderArray(newColumns);
    // Update any other state or perform actions related to reportColumns
  };

  const handleMoveDownColumns = (newColumns: any) => {

    setReportColumnsForColumnOrderArray(newColumns);
    // Update any other state or perform actions related to reportColumns
  };

  const handleMoveUpGroups = (newGroups: any) => {
    setReportGroupForGroupOrderArray(newGroups);
    // Update any other state or perform actions related to reportGroups
  };

  const handleMoveDownGroups = (newGroups: any) => {
    setReportGroupForGroupOrderArray(newGroups);
    // Update any other state or perform actions related to reportGroups
  };


  useEffect(() => {
    if (!stepperRef.current) {
      return
    }
    loadStepper()
  }, [stepperRef])

  useEffect(() => {
    renderReportFields();
  }, [])

  useEffect(() => {
    let stateItem: any = {}
    if (Object.keys(selectedRecord).length > 0) {
      const tempObj: any = selectedRecord;
      Object.keys(accountReportInitialsForUpdate).map((item) => {
        return stateItem[item] = tempObj[item];
      })
      setCurrentFieldsData(stateItem);
    }
    else {
      //setSelectedSystemReportDataSourceOption()
      setCurrentFieldsData(accountReportInitialsForAdd);
    }
  }, [selectedRecord])

  useEffect(() => {
    if (selectedSystemReportDataSourceOption) {
      const { label, value } = selectedSystemReportDataSourceOption;
      setCurrentFieldsData((prev: any) => ({
        ...prev,
        accountReportColumnList: [],
      }));
      setArrayOfArrays([]);
      dispatch(GetSystemReportDataSourceFieldBySystemReportDataSourceIdAndAccountReportIdAsync({ AccountReportId: AccountReportId, SystemReportDataSourceId: value }))
        .unwrap()
        .then((originalPromiseResult) => {
          if (originalPromiseResult.StatusCode === "200") {
            const updatedColumns = originalPromiseResult.Data.length > 0 && originalPromiseResult.Data.map((row: any) => ({
              ...row,
              chkSelect: getSelectCheckboxDynamically(row),
            }));

            const delay = 100;
            setTimeout(() => {
              setCurrentFieldsData((prev: any) => ({
                ...prev,
                accountReportColumnList: updatedColumns,
              }));
              // setCurrentFieldsData({
              //   ...currentFieldsData,
              //   accountReportColumnList: updatedColumns,
              // });
            }, delay);

            originalPromiseResult.Data.map((item: any, index: any) => {
              const newarray = getdynamicreportsummary(item.IsAllowSummaryCalculation, item.SystemReportDataSourceFieldId)
              setArrayOfArrays(prevState => [...prevState, { index, array: newarray }]);
            });
          } else if (originalPromiseResult.StatusCode === "404") {
            const delay = 100;
            setTimeout(() => {
              setCurrentFieldsData({
                ...currentFieldsData,
                accountReportColumnList: [],
              });
            }, delay);
          }
        })
        .catch((rejectedValueOrSerializedError) => { })
    }
  }, [selectedSystemReportDataSourceOption])

  const renderReportFields = async () => {
    dispatch(getAllDataInSingleRequestAsync(AccountReportId))
      .then((result) => {
        result.payload.ReportCategory.map((item: any) => {
          item.value = item.AccountReportCategoryId;
          item.label = item.AccountReportCategory;
          delete item.AccountReportCategoryId;
          delete item.AccountReportCategory;
        });
        SetReportCategoryArray(result.payload.ReportCategory);

        result.payload.ReportDataSource.map((item: any) => {
          item.value = item.SystemReportDataSourceId;
          item.label = item.ReportDataSourceName;
          delete item.SystemReportDataSourceId;
          delete item.ReportDataSourceName;
        });
        setSystemReportDataSourceArray(result.payload.ReportDataSource);

        result.payload.ReportSummary.map((item: any) => {
          item.value = item.SystemReportCalculationTypeId;
          item.label = item.CalculationType;
        });
        setSystemReportSummaryArray(result.payload.ReportSummary);

        let dataSourceList = result.payload.ReportDataSource;
        let systemReportDataSourceId = result.payload.SystemReportDataSourceId

        
        if (AccountReportId && isGuid(AccountReportId) && AccountReportId !== emptyGuid) {
          setSelectedSystemReportDataSourceOption(dataSourceList.find((item: any) => item.value === systemReportDataSourceId))
        }
        else {
          
          setSelectedSystemReportDataSourceOption(dataSourceList[0]);
        }
        setSystemReportDataSourceIdForReportCustomaize(systemReportDataSourceId);
        setIsDataReady(true);
      }).catch((error) => {
        setIsDataReady(true);
      });
  }

  const handleChange = (selectedReportCategoryOption: any) => {
    if (selectedReportCategoryOption) {
      const { label, value } = selectedReportCategoryOption;
      setCurrentFieldsData({ ...currentFieldsData, 'AccountReportCategoryId': value })
    }
  };

  const handleSystemReportDataSourceChange = (selectedSystemReportDataSourceOption: any) => {
    if (selectedSystemReportDataSourceOption) {
      const { label, value } = selectedSystemReportDataSourceOption;
      setSelectedSystemReportDataSourceOption(selectedSystemReportDataSourceOption)

      // Update systemReportDataSourceId in accountReportColumnList
      const updatedColumnList = currentFieldsData.accountReportColumnList.map((column: any) => {
        // Assuming each column has a property named systemReportDataSourceId
        return {
          ...column,
          SystemReportDataSourceId: selectedSystemReportDataSourceOption.value,
        };
      });

      // Update the state with the modified accountReportColumnList
      setCurrentFieldsData({
        ...currentFieldsData,
        accountReportColumnList: updatedColumnList,
      });

    }
  }

  const handleTextChange = (e: any) => {
    setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value.replace(/^ +/, '')) })
  }

  const handleRadioChange = (event: any) => {
    setSelectedOptionRadio(JSON.parse(event.target.value));
    setCurrentFieldsData({ ...currentFieldsData, 'IsConsolidated': event.target.value });
  };

  const handleNameChange = (e: any, SystemReportDataSourceFieldId: string, SystemReportDataSourceField: string) => {

    const currentindex = currentFieldsData.accountReportColumnList.findIndex(
      (item: any) => item.SystemReportDataSourceFieldId === SystemReportDataSourceFieldId
    );

    if (e.target === undefined) {
      const newArray = [...currentFieldsData.accountReportColumnList];

      if (e.label !== '<None>' && e.value !== '0') {
        newArray[currentindex] = {
          ...newArray[currentindex],
          [SystemReportDataSourceField]: e.value,
          'IsAllowSummaryCalculation': true, // Set to true if conditions are met
        };
      }
      else {

        newArray[currentindex] = {
          ...newArray[currentindex],
          [SystemReportDataSourceField]: e.value,
          'IsAllowSummaryCalculation': false, // Set to true if conditions are met
        };
      }

      // Update the state with the modified accountReportColumnList
      setCurrentFieldsData((prevData: any) => ({
        ...prevData,
        accountReportColumnList: newArray,
      }));
    } else {

      const newArray = [...currentFieldsData.accountReportColumnList];
      newArray[currentindex] = {
        ...newArray[currentindex],
        [SystemReportDataSourceField]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value),
      };

      setCurrentFieldsData((prevData: any) => ({
        ...prevData,
        accountReportColumnList: newArray,
      }));
    }

  };


  const getCurrentCalculationTypeId = (SystemReportDataSourceFieldId: any) => {
    // Find the element with the matching SystemReportDataSourceFieldId
    const foundColumn = accountReportColumnList.find(
      (column: any) => column.SystemReportDataSourceFieldId.toString() == SystemReportDataSourceFieldId.toString()
    );
    if (foundColumn) {
      //console.log(IsAllowSummaryCalculation,SystemReportDataSourceFieldId)
      // console.log('foundColumn:',foundColumn);
    }
    // If the element is found, return the SystemReportCalculationTypeId, otherwise return null or a default value
    return foundColumn ? foundColumn.SystemReportCalculationTypeId : null;
  };

  const getdynamicreportsummary = (IsAllowSummaryCalculation: any, systemReportDataSourceFieldId: any) => {
    let results: any = [];
    const SystemReportCalculationTypeId = getCurrentCalculationTypeId(systemReportDataSourceFieldId);

    if (IsAllowSummaryCalculation === false) {
      systemReportSummaryArray.forEach((reportSummary: any, index: any) => {
        if (reportSummary.ExcludeForCalculationSummary !== true) { }
        else {
          if (reportSummary.value !== SystemReportCalculationTypeId) {
            results.push({ label: reportSummary.label, value: reportSummary.value });
          }
          else if (SystemReportCalculationTypeId === null) {
            results.push({ label: reportSummary.label, value: reportSummary.value });
          }
        }
      });
    }
    else {
      results = Object.assign([], systemReportSummaryArray);
    }

    const defaultOption: any = { value: "0", label: "<None>" };
    const arrayWithDefault = [defaultOption, ...results];
    return arrayWithDefault;
  };

  const getSelectCheckboxDynamically = (row: any) => {

    let IsSelect: boolean = false;
    if (!AccountReportId || AccountReportId === emptyGuid) {
      if (selectedSystemReportDataSourceOption) {
        const { label, value } = selectedSystemReportDataSourceOption;
        if (value !== systemReportDataSourceIdForReportCustomaize) {
          if (row.DefaultAvailable) {
            IsSelect = true;
          }
        }
      }
    }
    else if (row.AccountReportColumnId && row.AccountReportColumnId !== emptyGuid) {
      IsSelect = true;
    }

    return IsSelect;
  };

  useEffect(() => {
    if (
      isDataReady &&
      tabStepper > 1 &&
      stepper.current &&
      currentFieldsData.accountReportColumnList !== undefined
    ) {
      stepper.current.goto(tabStepper);
      setCurrentStepperIndex(tabStepper);
      setSubmitButton(tabStepper === stepper.current.totalStepsNumber);
    }
  }, [isDataReady, currentFieldsData.accountReportColumnList]);
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {

    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
    setCurrentStepperIndex(stepper.current.currentStepIndex);
    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const trimAndCheckEmpty = (value: any, message: any) => {
    if (value.trim() === '') {
      ShowSwal("Validation", message, 'error');
      return true;
    }
    return false;
  };

  const submitStep = () => {
    if (!stepper.current) {
      return
    }

    if (stepper.current.currentStepIndex === 2) {
      for (let index = 0; index < currentFieldsData.accountReportColumnList.length; index++) {
        const item = currentFieldsData.accountReportColumnList[index];

        if (!item.Caption || item.Caption.trim() === '') {
          //alert(`Caption is required for item at row ${index + 1} in the account report column list`);
          ShowSwal("Validation", `Caption is required for item at row ${index + 1} in the account report column list`, 'error');
          // Focus on the textbox in the current row when validation fails
          if (textBoxRefs.current[index]) {
            textBoxRefs.current[index]!.focus();
          }
          return;
        }
      }

      dispatch(addAccountReportAsync({
        // AccountReportId: accountReportIdLast !== emptyGuid ? accountReportIdLast : AccountReportId, 
        AccountReportId: (accountReportIdLast && accountReportIdLast !== emptyGuid) ? accountReportIdLast : AccountReportId,
        currentFieldsData: currentFieldsData
      }))
        .unwrap()
        .then((originalPromiseResult) => {
          if (originalPromiseResult.StatusCode === "201") {
            if (stepper.current) {
              stepper.current.goNext();
              setCurrentStepperIndex(stepper.current.currentStepIndex);
              setAccountReportIdLast(originalPromiseResult.Data.AccountReportIdLast)
              const sortedColumns = JSON.parse(originalPromiseResult.Data.ReportColumn).sort((a :any, b : any) => a.ColumnOrder - b.ColumnOrder);
              setReportColumnsForColumnOrderArray(sortedColumns);
              const sortedGroups = JSON.parse(originalPromiseResult.Data.ReportGroup).sort((a: any, b: any) => b.ReportGroupFieldOrder - a.ReportGroupFieldOrder); 
              setReportGroupForGroupOrderArray(sortedGroups);
              setSubmitButton(true);
            }
            if (selectedFile) {
              // Create a FormData object
              const formData = new FormData();
              formData.append('file', selectedFile);
              // Make a POST request to the Web API
              fetchAPI("api/V2/Reports/UploadIcon", "POST", formData, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab", true)
                .then(response => response.json())
                .then(data => {
                  // Handle the response from the server
                  //console.log('File uploaded successfully:', data);
                })
                .catch(error => {
                  //console.error('Error uploading file:', error);
                });
            } else {
              //console.warn('No file selected for upload.');
            }
          }
        })
        .catch((rejectedValueOrSerializedError) => {
        })
    }
    else if (stepper.current.currentStepIndex === 3) {
      dispatch(addReportOrdersAsync({ AccountReportColumnList: reportColumnsForColumnOrderArray, AccountReportGroupList: (reportGroupForGroupOrderArray.length !== undefined ? reportGroupForGroupOrderArray : []) }))
        .unwrap()
        .then((originalPromiseResult) => {
          if (originalPromiseResult.StatusCode === "201") {
            let msg: string = "Report Added Successfully";
            if (AccountReportId && AccountReportId !== emptyGuid) { msg = "Report Updated Successfully" }

            originalPromiseResult.StatusCode === "201" ?
              ShowToast(msg, 'Success', "success", "toast-top-right") :
              ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

            if (stepper.current) {
              setCurrentStepperIndex(1);
              setSubmitButton(false);
              setCurrentFieldsData(accountReportInitialsForAdd);
              setFile(null);
              navigate('/myReports');
            }
          }
        })
        .catch((rejectedValueOrSerializedError) => {
        })
    }
    else if (stepper.current.currentStepIndex === 1) {
      if (trimAndCheckEmpty(currentFieldsData.ReportName, 'Report name required')) {
        return;
      }
      if (trimAndCheckEmpty(currentFieldsData.ReportDescription, 'Report description required')) {
        return;
      }
      const accountReportCategoryId = currentFieldsData.AccountReportCategoryId.trim();
      if (accountReportCategoryId === '' || accountReportCategoryId === emptyGuid) {
        ShowSwal("Validation", 'Report category required', 'error');
        return;
      }
      setIsLoadingLocal(true);
      setTimeout(() => {
        stepper.current?.goNext()
        setCurrentStepperIndex(stepper.current?.currentStepIndex || 1);
        setSubmitButton(false)
        setIsLoadingLocal(false);
      }, 500);

    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  // if (!location.state) {
  //   navigate('../MyReports');
  // }  
  return (
    <>
      {(isLoading || isLoadingLocal) && <Loader />}

      <div className="card card-custom admin-card">
        <div className="card-header sticky-top fixed-top bg-white">
          <h3 className="card-title fw-bold headerTitle">
            {/* {t('Report Design')} */}
            {getValueFromResource('Report Design', dispatch, t)}
          </h3>
          <div className="card-toolbar align-items-center">
           </div>
           <div className='d-flex flex-stack btn-flex rm'>
              
              {(currentStepperIndex === 2 || currentStepperIndex === 3) &&
                
                <div className='mr-2'>
                  
                  <button
                    onClick={prevStep}
                    type="button"
                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm"
                    data-kt-stepper-action='previous'
                  >
                    <i className="fa fa-angle-left"  style={{marginTop:'-1px'}}></i>
  
                    {/* {t('Back')} */}
                    {getValueFromResource('Back',dispatch, t)}
                  </button>
  
                </div>
                       }
                <div>
                  <button type='button'
                    className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent the default behavior (e.g., form submission)
                      submitStep();
                    }}
                  >
                    <span className='indicator-label'>
                      {!isSubmitButton && getValueFromResource('Continue', dispatch, t)}
                      {isSubmitButton &&
                       getValueFromResource('Finish', dispatch, t)}
                      <i className="fa fa-angle-right ms-1" style={{ marginTop: '-1px' }}></i>
                </span>
              </button>
            </div>
          </div>

        </div>
        {/* <div className="card-body pt-0 wizard-overflow-x"> */}
        <div className="card-Report-body pt-0 wizard-overflow-x">
          <div
            ref={stepperRef}
            className='stepper stepper-links d-flex flex-column '
            id='kt_create_account_stepper'
          >
            <div className='stepper-nav step '>
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                <h3 className='stepper-title'>
                  {/* {t('Report Definition')} */}
                  {getValueFromResource('Report Definition', dispatch, t)}
                </h3>
              </div>

              <div className='stepper-item' data-kt-stepper-element='nav'>
                <h3 className='stepper-title'>
                  {/* {t('Report Column')} */}
                  {getValueFromResource('Report Column', dispatch, t)}
                </h3>
              </div>

              <div className='stepper-item' data-kt-stepper-element='nav'>
                <h3 className='stepper-title'>
                  {/* {t('Report Ordering')} */}
                  {getValueFromResource('Report Ordering', dispatch, t)}
                </h3>
              </div>
            </div>
            {/* <form className='mx-auto  w-100 pt-0 pb-10' id='kt_create_account_form'> */}
            <div id='kt_create_account_form'>
              <div className='current' data-kt-stepper-element='content'>
                {currentStepperIndex === 1 &&
                  <div className='w-100'>
                    <div className='row mt-5'>


                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='required form-label fs-7 fw-normal mb-2'>
                          {/* {t('Report Name')} */}
                          {getValueFromResource('Report Name', dispatch, t)}
                        </label>
                        <input
                          type='text'
                          id="ReportName"
                          name='ReportName'
                          className="form-control fs-7 fw-normal"
                          value={currentFieldsData.ReportName}
                          onChange={(e) => handleTextChange(e)}
                        />

                      </div>


                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='form-label fs-7 fw-normal mb-2'>
                          {/* {t('Report Title')} */}
                          {getValueFromResource('Report Title', dispatch, t)}
                        </label>
                        <input
                          type='text'
                          id="ReportTitle"
                          name='ReportTitle'
                          className="form-control fs-7 fw-normal"
                          value={currentFieldsData.ReportTitle}
                          onChange={(e) => handleTextChange(e)}
                        />


                      </div>
                    </div>


                    <div className='row mt-4'>
                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='required form-label fs-7 fw-normal mb-2'>
                          {/* {t('Report Category')} */}
                          {getValueFromResource('Report Category', dispatch, t)}
                        </label>

                        <Select
                          value={reportCategoryArray.find((item: any) => item.value == currentFieldsData.AccountReportCategoryId)}
                          id="AccountReportCategoryId"
                          className="basic-single"
                          //value={selectedReportCategoryOption}
                          onChange={handleChange}
                          options={reportCategoryArray}
                          styles={dropDownSelectionStyles}
                          maxMenuHeight={maxMenuHeight}

                        />

                      </div>


                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='form-label fs-7 fw-normal mb-2'>
                          {/* {t('Upload Report Icon')} */}
                          {getValueFromResource('Upload Report Icon', dispatch, t)}
                        </label>

                        <input
                          type='file'
                          name='appname'
                          className="form-control fs-7 fw-normal"
                          onChange={handleFileChange}

                        />
                        <div>
                          {selectedFile ? (
                            <p>{getValueFromResource('Selected File', dispatch, t)} : {selectedFile.name}</p>
                          ) : (
                            <p className='fs-7 fw-normal mt-2'>
                              {/* {t('No file selected')} */}
                              {getValueFromResource('No file selected', dispatch, t)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className='row mt-4'>

                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='required form-label fs-7 fw-normal mb-2'>
                          {/* {t('Report Description')} */}
                          {getValueFromResource('Report Description', dispatch, t)}
                          {/* <span className='required'>{t('Report Description')}</span> */}

                        </label>
                        <textarea
                          id="ReportDescription"
                          name='ReportDescription'
                          className="form-control fs-7 fw-normal"
                          value={currentFieldsData.ReportDescription}
                          onChange={(e) => handleTextChange(e)}
                          rows={4}
                          cols={50}
                        />
                      </div>

                      {/* {(!AccountReportId || AccountReportId === emptyGuid) ? (
                        <div className='col-md-6  mb-5'></div>
                      ) : null} */}

                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='form-label fs-7 fw-normal mb-2'>
                          {/* {t('Report Header')} */}
                          {getValueFromResource('Report Header', dispatch, t)}
                        </label>
                        <textarea
                          id="ReportHeader"
                          name='ReportHeader'
                          className="form-control fs-7 fw-normal"
                          value={currentFieldsData.ReportHeader}
                          onChange={(e) => handleTextChange(e)}
                          rows={4}
                          cols={50}
                        />

                      </div>

                    </div>

                    <div className='col-md-6 col-lg-6 mb-2'>
                      <label className='form-label fs-7 fw-normal mb-2'>
                        {/* {t('Report Footer')} */}
                        {getValueFromResource('Report Footer', dispatch, t)}
                      </label>
                      <textarea
                        id="ReportFooter"
                        name='ReportFooter'
                        className="form-control fs-7 fw-normal"
                        value={currentFieldsData.ReportFooter}
                        onChange={(e) => handleTextChange(e)}
                        rows={4}
                        cols={50}
                      />

                    </div>


                    <div className='col-md-6 col-lg-6 mb-2'>

                      <label className="form-label fs-7 fw-normal mb-2">
                        {/* {t('Show Company Logo')} */}
                        {getValueFromResource('Show Company Logo', dispatch, t)}
                      </label>
                      <div className="form-check form-switch form-check-custom form-check-solid me-10">
                        <input
                          type="checkbox"
                          id="ShowCompanyLogo"
                          className="form-check-input h-20px w-30px"
                          checked={currentFieldsData.ShowCompanyLogo}
                          onChange={(e) => handleTextChange(e)} />
                      </div>

                    </div>
                    {(!AccountReportId || AccountReportId === emptyGuid) ? (
                      <div className='col-md-6 col-lg-6 mb-2'>
                        <label className='form-label fs-7 fw-normal mb-2'>
                          {/* {t('Report Type')} */}
                          {getValueFromResource('Report Type', dispatch, t)}
                        </label>

                        <div className="mb-3">
                          <div className="form-check form-check-custom form-check-solid form-check-sm">

                            <input
                              type="radio"
                              id="IsConsolidated"
                              className="form-check-input"
                              value="false"
                              checked={selectedOptionRadio === false}
                              onChange={handleRadioChange}

                            />
                            <label className="form-check-label fs-7 fw-normal mb-2" style={{ color: '#3f4254', fontWeight: 500 }}>
                              {/* {t('Detailed')} */}
                              {getValueFromResource('Detailed', dispatch, t)}
                            </label>

                            <input
                              type="radio"
                              id="IsConsolidated"
                              className="form-check-input ms-8"
                              value="true"
                              checked={selectedOptionRadio === true}
                              onChange={handleRadioChange}

                            />
                            <label className="form-check-label fs-7 fw-normal mb-2" style={{ color: '#3f4254', fontWeight: 500 }}>
                              {/* {t('Consolidated')} */}
                              {getValueFromResource('Consolidated', dispatch, t)}
                            </label>
                          </div>
                        </div>

                      </div>
                    ) : null}
                  </div>


                }
              </div>

              <div data-kt-stepper-element='content'>
                {/* {currentStepperIndex === 2 && <ReportColumn AccountReportId={AccountReportId} />} */}
                {currentStepperIndex === 2 &&

                  <div className='w-100'>
                    {/* <div className='card-body'> */}
                    {/* {isLoading ?
                        <div className="col-md-12">
                          <span className='indicator-progress' style={{ display: 'block' }}>
                            <span className='spinner-border spinner-border-md ms-2'></span>
                          </span>
                        </div>
                        : <> */}
                    <div className='row mt-5'>
                      <div className="col-md-12 mb-2">
                        <div className="row mb-2">
                          <label htmlFor="ReportName" className="col-md-1 col-form-label fs-7 fw-normal mb-2" style={{ width: '8%' }}>
                            {/* {t('Report Name')} */}
                            {getValueFromResource('Report Name', dispatch, t)}
                          </label>
                          <div className="col-md-10" style={{ width: '86.5%' }}>
                            <input
                              type="text"
                              id="ReportName"
                              className="form-control"
                              disabled={true}
                              value={currentFieldsData.ReportName}
                            />
                          </div>
                        </div>
                        <div className="row mb-2">
                          <label htmlFor="ReportDataSource" className="col-md-1 col-form-label fs-7 fw-normal mb-2" style={{ width: '8%' }}>
                            {/* {t('Report Datasource')} */}
                            {getValueFromResource('Report Datasource', dispatch, t)}
                          </label>
                          <div className="col-md-10" style={{ width: '86.5%' }}>
                            <Select
                              value={selectedSystemReportDataSourceOption}
                              onChange={handleSystemReportDataSourceChange}
                              options={systemReportDataSourceArray}
                              isDisabled={(AccountReportId !== undefined && AccountReportId !== null && AccountReportId !== '' && AccountReportId !== emptyGuid) ? true : false}
                              styles={dropDownSelectionStyles}
                              maxMenuHeight={maxMenuHeight}
                              menuPortalTarget={document.body}
                            />
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="table-responsive">
                        <table className="table table-row-bordered  align-middle gs-1" >
                          <thead>
                            <tr className="thHeading align-middle">
                              <th className='w-100px'>
                                {/* {t('Select')} */}
                                {getValueFromResource('Select', dispatch, t)}
                              </th>
                              <th className='min-w-100px'>
                                {/* {t('Report Column')} */}
                                {getValueFromResource('Report Column', dispatch, t)}
                              </th>
                              <th className='min-w-100px text-center'>
                                {/* {t('Caption')} */}
                                {getValueFromResource('Caption', dispatch, t)}
                              </th>
                              <th className='w-100px text-center'>
                                {/* {t('Group')} */}
                                {getValueFromResource('Group', dispatch, t)}
                              </th>
                              <th className='min-w-100px text-center'>
                                {/* {t('Show Summary')} */}
                                {getValueFromResource('Show Summary', dispatch, t)}
                              </th>
                              <th className='min-w-100px text-center'>
                                {/* {t('Formula')} */}
                                {getValueFromResource('Formula', dispatch, t)}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentFieldsData.accountReportColumnList && Object.values(currentFieldsData.accountReportColumnList).map((accountReportColumnDetails: any, index: any) =>
                              <tr key={index}>
                                {/* <td className="form-check form-check-custom form-check-solid form-check-sm"> */}
                                <td>
                                  <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                    <input
                                      id="chkSelect"
                                      className='form-check-input widget-9-check'
                                      type='checkbox'
                                      style={{ marginLeft: '7px' }}
                                      checked={accountReportColumnDetails.chkSelect}
                                      onChange={e => handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'chkSelect')}
                                    />
                                  </div>
                                  {/* <input
                                          id="chkSelect"
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={accountReportColumnDetails.chkSelect}
                                          //checked={getSelectCheckboxDynamically(accountReportColumnDetails.AccountReportColumnId, accountReportColumnDetails.DefaultAvailable, accountReportColumnDetails.SystemReportDataSourceFieldId)}
                                          onChange={e => handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'chkSelect')}

                                        /> */}
                                </td>
                                <td>{accountReportColumnDetails.SystemReportDataSourceField}</td>
                                <td>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    className="form-control fs-7 fw-normal"
                                    id='Caption'
                                    //value={accountReportColumnDetails.Caption !== null ? accountReportColumnDetails.Caption : accountReportColumnDetails.SystemReportDataSourceFieldCaption}
                                    value={accountReportColumnDetails.Caption}
                                    onChange={e => handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'Caption')}
                                    name='Caption'
                                    ref={(el) => {
                                      textBoxRefs.current[index] = el;
                                    }}  // Assign the ref based on the index
                                  />
                                </td>
                                {/* <td className="form-check form-check-custom form-check-solid form-check-sm " > */}
                                <td>

                                  <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                    <input
                                      id="IsAccountReportGroupExist"
                                      className='form-check-input widget-9-check'
                                      type='checkbox'
                                      style={{ marginLeft: '42px' }}
                                      checked={accountReportColumnDetails.IsAccountReportGroupExist}
                                      onChange={e => handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'IsAccountReportGroupExist')}
                                    />
                                  </div>
                                  {/* <input
                                          id="IsAccountReportGroupExist"
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={accountReportColumnDetails.IsAccountReportGroupExist}
                                          onChange={e => handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'IsAccountReportGroupExist')}
                                        /> */}

                                </td>
                                <td>
                                  <Select
                                    key={index}
                                    options={(arrayOfArrays && arrayOfArrays[index] && arrayOfArrays[index].array) ? arrayOfArrays[index].array : []}
                                    isSearchable={true}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    onChange={e => handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'SystemReportCalculationTypeId')}
                                    id="SystemReportCalculationTypeId"
                                    value={systemReportSummaryArray.find((item: any) => item.SystemReportCalculationTypeId === accountReportColumnDetails.SystemReportCalculationTypeId)}
                                    defaultValue={{ value: "0", label: "<None>" }}
                                    styles={dropDownSelectionStyles}
                                    maxMenuHeight={maxMenuHeight}
                                  />

                                </td>
                                <td>
                                  {accountReportColumnDetails.IsFormulaField ? (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                      <input
                                        type="text"
                                        // className="form-control"
                                        className="form-control fs-7 fw-normal"
                                        id="ColumnFormula"
                                        value={accountReportColumnDetails.ColumnFormula}
                                        onChange={(e) =>
                                          handleNameChange(e, accountReportColumnDetails.SystemReportDataSourceFieldId, 'ColumnFormula')
                                        }
                                      />
                                      <a
                                        id="imgFormula"
                                        // href="http://www.livetecs.com/timelivehelp/Default.htm#Understanding_Formula_Columns.htm"
                                        href="https://www.livetecs.com/timelivehelp-v13/1/en/topic/understanding-formula-columns"
                                        // href={config.FORMULA_HELP_URL || '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ paddingLeft: '8px' }}
                                      >
                                        {/* <img
                                          id="kt_OffCanvas"
                                          src={toAbsoluteUrl('/media/images/Help.gif')}
                                          alt="TimeLive Help"
                                          style={{ marginLeft: '5px' }} // Adjust the margin as needed
                                        /> */}
                                        {/* [imgFormula] */}
                                        <KTIcon iconName='question-2' className={btnIconClass} />

                                      </a>

                                    </div>
                                  ) : null}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {currentFieldsData.accountReportColumnList.length == 0 &&
                          <div className=''>
                            <p className='noDataFound'>
                              {/* {t('No Record Found')} */}
                              {getValueFromResource('No Record Found', dispatch, t)}
                            </p>
                          </div>}
                      </div>
                    </div>
                    {/* </>
                      } */}
                    {/* </div> */}
                  </div>
                }
              </div>

              <div data-kt-stepper-element='content'>
                {currentStepperIndex === 3 &&
                  <>
                    <div className='w-100'>
                      <div className="col-md-12 mb-2">
                        <div className="row mt-5">
                          <label htmlFor="ReportName" className="col-md-1 col-lg-1 col-form-label fs-7 fw-normal mb-2" style={{ width: '8%' }}>
                            {/* {t('Report Name')} */}
                            {getValueFromResource('Report Name', dispatch, t)}
                          </label>
                          <div className="col-md-10" style={{ width: '86.5%' }}>
                            <input
                              type="text"
                              id="ReportName"
                              className="form-control fs-7 fw-normal"
                              style={{ backgroundColor: '#f7f8f9' }}
                              disabled={true}
                              value={currentFieldsData.ReportName}
                            />
                          </div>
                        </div>
                      </div>
                      <hr></hr>
                      <div className='row justify'>
                        {/* <div className="'col-md-2"> </div> */}
                        <div className='col-md-5' style={{ width: '45%' }}>
                          {reportColumnsForColumnOrderArray && Object.keys(reportColumnsForColumnOrderArray).length > 0 &&
                            <DraggableList
                              list={reportColumnsForColumnOrderArray}
                              headerName=
                              // {t("Column Order")}
                              {getValueFromResource('Column Order', dispatch, t)}
                              dataTextField="Caption"
                              dataValueField="AccountReportColumnId"
                              onMoveUp={handleMoveUpColumns}
                              onMoveDown={handleMoveDownColumns}
                            />
                          }
                        </div>
                        <div className='col-md-5'>
                          {reportGroupForGroupOrderArray && Object.keys(reportGroupForGroupOrderArray).length > 0 &&
                            <DraggableList
                              list={reportGroupForGroupOrderArray}
                              headerName=
                              // {t("Group Order")}
                              {getValueFromResource('Group Order', dispatch, t)}
                              dataTextField="ReportGroupFieldLabel"
                              dataValueField="AccountReportGroupId"
                              onMoveUp={handleMoveUpGroups}
                              onMoveDown={handleMoveDownGroups}
                            />

                          }
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>

              {/* <div className="fix"> */}



            </div>

          </div>
          {/* </form> */}

        </div>
      </div>


      {/* </div > */}

    </>
  )
}
